/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Trace_Weighing_TitleInputs */

const vi_trace_weighing_title = /** @type {(inputs: Trace_Weighing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cân nguyên liệu`)
};

/**

* @param {Trace_Weighing_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const trace_weighing_title = /** @type {((inputs?: Trace_Weighing_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Trace_Weighing_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_trace_weighing_title(inputs)
});